import React from 'react';
import { CoinVerticalIcon } from './icons';
import styles from './styles.module.css';
import { Typography } from 'fronton-react';
/**
 * Компонент BestPriceTag для отображения плашки "Лучшая цена".
 *
 * @param {BestPriceTagProps} props - Свойства компонента.
 * @param {String} props.text - Текст плашки.
 * @param {ReactElement} props.icon - Переопределение иконки плашки.
 * @returns {React.ReactElement} Возвращает плашку с иконкой.
 */
export const BestPriceTag = ({ text, icon = React.createElement(CoinVerticalIcon, null), ...htmlProps }) => (React.createElement("div", { className: styles.tagWrapper, ...htmlProps },
    React.createElement("div", { className: styles.icon }, icon),
    React.createElement("div", { className: styles.textWrap },
        React.createElement(Typography, { className: styles.bestPriceTagText, variant: "overline" }, text))));
//# sourceMappingURL=best-price-tag.js.map